<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        (click)="create()"
        [disabled]="anyFieldInvalid()"
        *ngIf="!paramId"
        >Maschine anlegen</ion-button
      >
      <ion-button
        (click)="update()"
        [disabled]="anyFieldInvalid()"
        *ngIf="paramId"
        >Maschine aktualisieren</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    @if(paramId){
    <div class="field" style="display: flex">
      <lib-image-preview
        [fileOrBlob]="profilePicture"
        style="height: 200px"
        (click)="openFile()"
      ></lib-image-preview>
      <div style="margin-left: 10px">
        <ion-button (click)="openImageInput()" style="min-width: 160px"
          ><ion-icon
            name="cloud-upload-outline"
            slot="start"
            class="white"
          ></ion-icon
          >Bild ändern</ion-button
        >
      </div>
    </div>
    }

    <lib-upload
      style="width: 100%"
      (filesChanged)="setUploadFiles($event, true)"
      [isProfilePicture]="true"
      [autoUpload]="true"
      [machineId]="paramId"
      [displayName]="
        machine?.inventoryNumber +
        ' ' +
        machine?.manufacturer +
        ' ' +
        machine?.type
      "
    ></lib-upload>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        placeholder="Radlader, Bagger, Container..."
        type="text"
        mode="md"
        [(ngModel)]="this.machine.category"
        ><div slot="label">Geräteart</div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        placeholder="TL80, MS03, MS08..."
        [(ngModel)]="this.machine.type"
        ><div slot="label">Typ</div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.constructionYear"
        ><div slot="label">Baujahr</div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.manufacturer"
        ><div slot="label">Hersteller</div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.serialNumber"
        ><div slot="label">Serien-/Fabriknummer</div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.inventoryNumber"
        (ionInput)="handleInventoryNumberInput($event)"
        ><div slot="label">Inventarnummer</div></ion-input
      >
      @if(showDuplicateInventoryNumberError){
      <div>Inventarnummer bereits vergeben</div>
      }
    </div>
    <div class="field">
      <ion-textarea
        label="Bemerkungen"
        labelPlacement="floating"
        fill="outline"
        [autoGrow]="true"
        mode="md"
        [(ngModel)]="machine.notes"
        placeholder="Bemerkungen hinzufügen.."
      ></ion-textarea>
    </div>
    <div class="field">
      <ion-checkbox
        stlye="margin-bottom:10px"
        [(ngModel)]="this.machine.inspectionFree"
        >Keine DGUV-Prüfung notwendig</ion-checkbox
      >
    </div>
    @if(machine.inspectionFree && !machine.nextManualInspection){
    <div class="field">
      <ion-button (click)="showDatePicker = true" fill="outline"
        >Manuelles Prüfdatum hinzufügen</ion-button
      >
    </div>

    } @if(machine.inspectionFree && (machine.nextManualInspection ||
    showDatePicker)){
    <div class="field stretch space-between">
      <div>Nächste Prüfung (TÜV etc..)</div>
      <div class="stretch">
        <lib-date-time-picker
          [type]="'date'"
          [inputDateZulu]="machine.nextManualInspection"
          (selectedDateChanged)="dateChanged($event)"
        ></lib-date-time-picker>
        <ion-icon
          name="trash-outline"
          class="red"
          (click)="removeManualInspection()"
        ></ion-icon>
      </div>
    </div>
    } @if(paramId){
    <div class="field stretch space-between">
      <div>Dokumente</div>
      @if(filesToUpload?.length < 1){
      <ion-button (click)="openFileInput()"
        ><ion-icon
          name="cloud-upload-outline"
          slot="start"
          class="white"
        ></ion-icon
        >Dokumente hinzufügen</ion-button
      >
      }
    </div>

    @if(paramId){
    <lib-upload
      style="width: 100%"
      [machineId]="paramId"
      (filesChanged)="setUploadFiles($event, false)"
      [displayName]="
        machine?.inventoryNumber +
        ' ' +
        machine?.manufacturer +
        ' ' +
        machine?.type
      "
      (uniqueIdChanged)="setUniqueId($event)"
    ></lib-upload>
    } @for(doc of machineDocuments; track doc.id){
    @if(!filesToDelete.includes(doc.id)){
    <div class="stretch space-between document">
      <div class="centered">
        <ion-icon
          [name]="state.getIcon(doc)"
          style="margin-right: 5px"
        ></ion-icon>
        <div>{{ doc.displayName }}</div>
      </div>
      <ion-icon
        name="trash-outline"
        class="red"
        (click)="deleteFile(doc.id)"
      ></ion-icon>
    </div>
    } } }
    <br />
  </div>
</ion-content>
